module.exports = new __parcel__URL__("smart_link.98982781.gif").toString();